import ComplaintSimpleView from './ComplaintSimpleView'

export default ComplaintSimpleView
